/**
 * Copyright 2026 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

import NotificationBlock from '@/components/AZCustomComponent/NotificationBlock/NotificationBlockV2';
import type { DealConstraint, DealConstraintSkuDetails } from '../../../interface';
import styles from './ConstraintDetails.module.scss';
import { BundleDealConstraintCardV2 } from '../BundleDealConstraintCard/BundleDealConstraintCardV2';

type MergedItem = {
  constraint: DealConstraint;
  skuDetail: DealConstraintSkuDetails;
};

type Props = {
  loadError: string | null | undefined;
  addToCartError: string | null | undefined;
  mergedItems: MergedItem[];
  onConstraintSwapClick: (
    constraint: DealConstraint,
    constraintSkuDetails: DealConstraintSkuDetails,
  ) => void;
  dealId: string;
};
const ConstraintDetails = ({
  addToCartError,
  mergedItems,
  onConstraintSwapClick,
  dealId,
}: Props) => {
  return (
    <div className={styles.listContainer}>
      {!!addToCartError && (
        <div className={styles.errorContainer}>
          <NotificationBlock type="error" message={addToCartError} />
        </div>
      )}

      {mergedItems.map((item) => (
        <BundleDealConstraintCardV2
          key={`${dealId}-constraint-${item.constraint.id}`}
          constraint={item.constraint}
          skuDetails={item.skuDetail}
          onSwapClick={() => onConstraintSwapClick(item.constraint, item.skuDetail)}
          showSwapButton={item.constraint.skus.length > 1}
        />
      ))}
    </div>
  );
};

export default ConstraintDetails;
